export default {
  buttons: {
    add: 'Ajouter',
  },
  AddOn: {
    label: 'Extension',
    title: 'Obtenez votre application mobile',
    subscribed: 'Abonné',
    cta: 'Obtenez votre application mobile',
    price_per_month: '{{price}} / mois',
    tax_included: 'taxes applicables incluses',
    apple_developer_note:
      "Nécessite un compte Apple Developer (99 $/an, payé à Apple) au nom de l'entité juridique du restaurant.",
    features: {
      stores: "Disponible sur l'App Store et Google Play",
      push: 'Notifications push à vos clients',
      loyalty: 'Points de fidélité et récompenses',
      commission: 'Commande directe avec 0 % de commission',
    },
  },
};
